import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    id: "skills",
    class: "w-full"
};
const _hoisted_2 = { class: "mb-16 md:flex justify-between items-end" };
const _hoisted_3 = { class: "text-sm font-mono uppercase tracking-widest opacity-50 mb-4 md:mb-0" };
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-3 gap-12" };
const _hoisted_5 = { class: "flex items-center gap-3 mb-6" };
const _hoisted_6 = { class: "text-lg font-bold uppercase tracking-wider" };
const _hoisted_7 = { class: "space-y-3" };
const _hoisted_8 = { class: "text-sm font-medium opacity-80" };
import { computed } from 'vue';
import { Icon } from '@iconify/vue';
import { SKILLS, CONTENT } from '../constants';
import { useLanguage } from '../composables/useLanguage';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Skills',
    setup(__props) {
        const { language } = useLanguage();
        const text = computed(() => CONTENT[language.value]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h3", _hoisted_3, _toDisplayString(text.value.sections.skills), 1 /* TEXT */),
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "h-[1px] flex-grow bg-black/10 dark:bg-white/10 ml-8 hidden md:block" }, null, -1 /* CACHED */))
                ]),
                _createElementVNode("div", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SKILLS), (category) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: category.title,
                            class: ""
                        }, [
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_unref(Icon), {
                                    icon: category.icon,
                                    class: "w-5 h-5 text-accent"
                                }, null, 8 /* PROPS */, ["icon"]),
                                _createElementVNode("h4", _hoisted_6, _toDisplayString(category.title), 1 /* TEXT */)
                            ]),
                            _createElementVNode("ul", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.skills, (skill) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: skill,
                                        class: "flex items-center justify-between border-b border-black/5 dark:border-white/5 pb-2"
                                    }, [
                                        _createElementVNode("span", _hoisted_8, _toDisplayString(skill), 1 /* TEXT */),
                                        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "w-1.5 h-1.5 bg-accent opacity-0 group-hover:opacity-100 transition-opacity rounded-none" }, null, -1 /* CACHED */))
                                    ]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ]));
                    }), 128 /* KEYED_FRAGMENT */))
                ])
            ]));
        };
    }
});
